import { observer } from "mobx-react-lite";

import { useRubricatorPageState } from "./page.state";
import { RubricatorPageView } from "./page.view";

export const RubricatorPage = observer(() => {
  const state = useRubricatorPageState();
  return <RubricatorPageView state={state} />;
});
